import React from "react";

const TermsAndConditions = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms and Conditions</h1>
      <ol>
        <li>Work will be started after receiving your receipt of the confirmed work order.</li>
        <li>Freight charges will be applicable.</li>
        <li>18% GST will be applicable.</li>
        <li>Payment should be made within 5 days after receiving the invoice.</li>
        <li>Other conditions will be discussed in the quotation according to the scope of work.</li>
      </ol>
    </div>
  );
};

export default TermsAndConditions;
